(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Opzioni_ticketDetailController', Opzioni_ticketDetailController);

    Opzioni_ticketDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Opzioni_ticket', 'Campagna'];

    function Opzioni_ticketDetailController($scope, $rootScope, $stateParams, previousState, entity, Opzioni_ticket, Campagna) {
        var vm = this;

        vm.opzioni_ticket = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:opzioni_ticketUpdate', function(event, result) {
            vm.opzioni_ticket = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
